import { VStack } from '@chakra-ui/react';
import { memo } from 'react';
import ListenAudio from '../HelperComponents/ListenAudio';
import RecordAudio from '../HelperComponents/RecordAudio';
import noop from 'lodash/noop';
import useMediaOptions from './useMediaOptions';

const ListenWithRecord = memo(({ 
  exercise, 
  setSelectedAnswer,
  disabled,
  ...props 
}) => {
  const {
    currentlyPlaying,
    onAudioPlay,
    stopAllAudio
  } = useMediaOptions({
    exercise,
    hasAudio: true
  });

  return (
    <VStack 
      spacing={10}
      width="100%"
      alignItems="center"
      data-testid={props['data-testid']}
    >
      <ListenAudio 
        data={exercise}
        audioControl={{
          currentlyPlaying,
          onAudioPlay,
          stopAllAudio
        }}
      />
      <RecordAudio
        key={exercise.id}
        setSelectedAnswer={setSelectedAnswer}
        onStopRecording={noop}
        disabled={disabled}
        {...props}
      />
    </VStack>
  );
});

export default ListenWithRecord;